<template>
	<main class="vx-row">
		<div class="vx-col lg:w-1/2 w-full">
			<form>
				<p class="mb-2"><strong>Password Lama</strong></p>
				<vs-input name="oldPassword" v-validate="'required'" v-model="oldPassword" type="password" class="rounded w-full mb-6" />
				<span v-if="errors.has('oldPassword')" class="block mb-4 text-danger">{{ errors.first('oldPassword') }}</span>
				<p class="mb-2"><strong>Password Baru</strong></p>
				<vs-input name="newPassword" v-validate="'required'" v-model="newPassword" type="password" class="rounded w-full mb-6" ref="newPassword" />
				<span v-if="errors.has('newPassword')" class="block mb-4 text-danger">{{ errors.first('newPassword') }}</span>
				<p class="mb-2"><strong>Konfirmasi Password Baru</strong></p>
				<vs-input name="confNewPassword" v-validate="'confirmed:newPassword'" v-model="confNewPassword" type="password" class="rounded w-full mb-6" />
				<span v-if="errors.has('confNewPassword')" class="block mb-4 text-danger">{{ errors.first('confNewPassword') }}</span>
				<br>
				<vs-button class="rounded" @click.prevent="submit" id="btn-password">
					Submit
				</vs-button>
			</form>
		</div>
	</main>
</template>
<script>
	import { mapState } from 'vuex'
	import { Validator } from 'vee-validate'

	const dict = {
		custom: {
			oldPassword: {
				required: 'Harap masukan password lama anda'
			},
			newPassword: {
				required: 'Harap masukan password baru anda'
			},
			confNewPassword: {
				confirmed: 'Konfirmasi Password baru tidak sama'
			}
		}
	}

	Validator.localize('en', dict)

	export default {
		data: () => ({
			oldPassword: null,
			newPassword: null,
			confNewPassword: null
		}),
		computed: {
			...mapState('auth', ['profile'])
		},
		methods: {
			submit() {
				this.$validator.validateAll().then(res => {
					if(res) {
						const payload = {
							id: this.profile.id,
							old_password: this.oldPassword,
							password: this.newPassword
						}

						this.$vs.loading()

						this.$store.dispatch('auth/changePassword', payload)
						.then(() => {
							this.$vs.loading.close()
							this.$vs.notify({
								title: 'Password berhasil diubah',
								text: '',
								color: 'success',
								position: 'top-right'
							})
						})
						.catch(e => {
							this.$vs.loading.close()
							this.showError(e)

							return false
						})
					}
				})
			}
		}
	}
</script>